module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__printers"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.printersAmount,
      "link": "",
      "table-id": "printers"
    },
    on: {
      "create": _vm.addPrinter,
      "refresh": _vm.getPrinters
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(scope) {
        return (scope.item.status) ? _c('div', {
          staticClass: "printer-status",
          style: (('color: ' + ((scope.item.status.color) ? scope.item.status.color : '#000') + ';'))
        }, [_c('span', [_vm._v(_vm._s(scope.item.status.name))])]) : _vm._e()
      }
    }, {
      key: "stock",
      fn: function(scope) {
        return _c('div', {
          staticClass: "printer-stock"
        }, [_c('span', [_vm._v(_vm._s((scope.item.stock && scope.item.stock.name) ? scope.item.stock.name : 'Не установлен'))])])
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.printers),
      callback: function($$v) {
        _vm.printers = $$v
      },
      expression: "printers"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7abf863c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/Printers.vue
// module id = 1204
// module chunks = 0